import { render, staticRenderFns } from "./TypeEnterpriseForm.vue?vue&type=template&id=471baad2&"
import script from "./TypeEnterpriseForm.vue?vue&type=script&lang=js&"
export * from "./TypeEnterpriseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports